var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTsunamiLeafLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 24,
    fill: "#0F766E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 74C42.5 56.5 53.5 52.5 65 62C77 72 87 72.5 98 54",
    stroke: "#ECFEFF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 91C43 78 54.5 75 66 82C78.5 89.5 88.5 88.5 98 77",
    stroke: "#A7F3D0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 36C53 46 70 46 88 36",
    stroke: "#F0FDFA",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTsunamiLeafLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tsunami-leaf-logo.87a8e0cdf3c3970872066c44bbdeafb0.svg";